import { lazy } from 'react';

const CustomersInvoices = lazy(() => import('./CustomersInvoices'));

export default CustomersInvoices;
